import {
    makeType
    // initLog
} from "./ui/core/types"

import {
    // makeType,
    initLog
} from "./ui/core/base"

import { Stream } from "./ui/core/dispatcher-flyd"

import { modelChanged } from "./ui/components/common"

import UI from "./ui/core/ui"

// const SELECTED = "s_selected-item"
// const ITEM = "item-selector"

const proto = {
    name: "SlidingMenu",
    initLog,

    init() {
        return {
            open: false
        }
    },

    update(msg, model) {
        this.log.warn (`msg: ${msg.type} model:`, Object.assign ({}, model))

        switch (msg.type) {
            case "click":
                if (model.open === false) {
                    model.open = true
                } else {
                    model.open = false
                }
                break
            // default:
            //     this.log.info("unhandled event:", msg.type, msg);
        }
        return model
    },

    view(model) {
        // this.log.warn(`view: state:`, Object.assign({}, model));
        if (model.open === true) {
            this.dom.removeClass ("closed")
        } else {
            this.dom.addClass ("closed")
        }
        return model
    },

    initialize(dom) {
        this.initLog ()
        this.dom = dom
        this.openToggle = document.findByRole ("open-menu")[0]
        this.toggle = this.dom.findByRole ("menu-close")[0]

        // this.input = this.dom.getElement('input');
        // this.log.warn("toggle:", this.toggle);

        let currentModel = this.init ()

        this.eventStream = new Stream ()

        this.eventStream.map (msg => {
            let model = Object.assign ({}, currentModel)
            model = this.update (msg, model)
            if (modelChanged (currentModel, model)) {
                model = this.view (model)
            }
            currentModel = model
        })

        this.toggle.addEvent ("click", this.eventStream.stream)
        this.openToggle.addEvent ("click", this.eventStream.stream)
    }
}

const SlidingMenu = makeType (proto)

// console.log(`sliding menu?`, SlidingMenu);

export default SlidingMenu

UI.register ("sliding-menu", SlidingMenu)

// console.log(`here`);
